var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNoImage = function SvgNoImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3F576D",
    d: "M36.5 36.5 22.35 22.35 5.984 5.983 3.5 3.5 1.15 5.85 5 9.717v21.95C5 33.5 6.5 35 8.334 35h21.95l3.85 3.85zM8.334 30l5.833-7.5 4.167 5.017L20.284 25l5 5zM35 30.283 9.717 5h21.95C33.5 5 35 6.5 35 8.333z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })))));
};
export default SvgNoImage;